import React, { Component } from "react";
import { connect } from "react-redux";
import MobileSearchSheetModal from "../Header/JobSearchBar/Modal/MobileSearchModal";
import MessageModal from "./MessageModal";
import PreLaunchSignupSuccess from "./PreLaunchSignupSuccess";
import RegistrationModal from "./Registration/RegistrationModal";
import ModalBottomSheet from "../UI/Sheet/BottomSheet";
import ChatMessageDetailPage from "../Chats/Messages/MessagePage";
import ApplicationProcessDetails from "../Candidate/ApplyCandidate/Components/ApplicationProcessDetails";
import FindYourWorkplacePage from "../UI/FindYourWorkplacePage";
import AddEditWorkReference from "../Candidate/ApplyCandidate/Components/AddEditWorkReference";
import CandidateDetailView from "../Candidate/CandidateDetail/CandidateViewPage";
import AppModal from "./AppModal";
import OnboardingCompletionModal from "./OnboardingCompletionModal";

import loadable from "@loadable/component";
import {closeModal, closeAllModals } from "../../redux/Modals/ModalActions";
import LoginModal from "./Login/LoginModal";
import AuthOverlay from "../Authentication/authOverlay";

const MediaViewModal = loadable(() => import("../MediaViewer/MediaViewModal"), {
  ssr: false,
});

const ModalCollection = {
  MessageModal,
  PreLaunchSignupSuccess,
  CandidateDetailView,
  ApplicationProcessDetails,
  ChatMessageDetailPage,
  MobileSearchSheetModal,
  MediaViewModal,
  RegistrationModal,
  LoginModal,
  AuthOverlay,
  ModalBottomSheet,
  FindYourWorkplacePage,
  AddEditWorkReference,
  AppModal,
  OnboardingCompletionModal,
};

const mapState = (state) => {
  
  // Handle both old and new state structures for backward compatibility
  const modalState = state.modal;
  
  if (!modalState) {
    return { modals: [], modalHistory: [] };
  }
  
  // If using old structure (single modal)
  if (modalState.modalType && !modalState.modals) {
    return {
      modals: [{
        id: 'legacy_modal',
        modalType: modalState.modalType,
        modalProps: modalState.modalProps || {},
        timestamp: Date.now(),
        zIndex: 1000,
      }],
      modalHistory: [],
    };
  }
  
  // New structure
  return {
    modals: modalState.modals || [],
    modalHistory: modalState.history || [],
  };
};

const mapDispatch = {
  closeModal,
  closeAllModals,
};

class ModalManager extends Component {
  componentDidMount() {
    // Add keyboard event listener for ESC key
    document.addEventListener('keydown', this.handleKeyPress);
  }

  componentWillUnmount() {
    // Cleanup event listener
    document.removeEventListener('keydown', this.handleKeyPress);
  }

  handleKeyPress = (event) => {
    // Close last modal on ESC key press
    if (event.key === 'Escape' && this.props.modals.length > 0) {
      this.props.closeModal();
    }
    
    // Close all modals on Ctrl+Shift+Escape (or Cmd+Shift+Escape on Mac)
    if (event.key === 'Escape' && (event.ctrlKey || event.metaKey) && event.shiftKey) {
      this.props.closeAllModals();
    }
  };

  renderModal = (modal, index) => {
    const SelectedModal = ModalCollection[modal.modalType];
    
    if (!SelectedModal) {
      console.warn(`Modal type "${modal.modalType}" not found in ModalCollection`);
      return null;
    }

    // Ensure modalProps is an object, fallback to empty object if undefined
    const safeModalProps = modal.modalProps || {};
    const isTopModal = index === this.props.modals.length - 1;

    return (
      <div
        key={modal.id}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: modal.zIndex,
          textAlign: "center",
          pointerEvents: isTopModal ? 'auto' : 'none',
        }}
        data-modal-id={modal.id}
        data-modal-type={modal.modalType}
        data-is-top-modal={isTopModal}
      >
        <SelectedModal
          {...safeModalProps}
          modalId={modal.id}
          isLastModal={isTopModal}
          modalIndex={index}
          totalModals={this.props.modals.length}
        />
      </div>
    );
  };

  render() {
    const { modals } = this.props;

    if (!modals || modals.length === 0) {
      return <div />;
    }

    return (
      <>
        {modals.map((modal, index) => this.renderModal(modal, index))}
      </>
    );
  }
}

export default connect(mapState, mapDispatch)(ModalManager);